import { EventKey } from "PFTypes/event_key";
import { KeyboardEvent } from "react";

export const isActionKeyPressed = (event: KeyboardEvent) =>
  [EventKey.Enter, EventKey.Space].includes(event.key as EventKey);
